export default __webpack_public_path__ + "static/black-brand-banner-c998b3d9043416ae41ebc672ed994c65.jpg";